import { useSelector } from 'react-redux';

import { EARN_COINS_HINT_KEYS_LIST } from '@lootboy/lib/constants';
import { userSelector } from '@lootboy/lib/selectors';

import BalancePopup from '~/components/molecules/BalancePopup';
import RecruitPopup from '~/components/RecruitPopup';

import { CARDS_PATH, COMICS_PATH, DAILY_PATH } from '~/routes/paths';

import coinsM from '~/assets/images/currencies/Coin M Stack Solid.png';
import coinsS from '~/assets/images/currencies/Coin S Stack Solid 1.png';
import coinsXS from '~/assets/images/currencies/Coin XS Stack Solid.png';

const hints = {
  [EARN_COINS_HINT_KEYS_LIST.COMICS]: {
    name: 'comics',
    img: coinsS,
    to: COMICS_PATH,
  },
  [EARN_COINS_HINT_KEYS_LIST.BOOST]: {
    img: coinsM,
    name: 'boost',
    highlight: true,
    to: DAILY_PATH,
  },
  [EARN_COINS_HINT_KEYS_LIST.INVITES]: {
    img: coinsS,
    name: 'invite',
    component: RecruitPopup,
  },
  [EARN_COINS_HINT_KEYS_LIST.SHREDDING]: {
    img: coinsXS,
    name: 'shred',
    to: CARDS_PATH,
  },
};

export default function EarnCoinsPopup(): JSX.Element {
  const { lootcoinBalance } = useSelector(userSelector);
  return (
    <BalancePopup
      coins={lootcoinBalance}
      src={coinsS}
      translation="EarnCoinsView"
      hints={hints}
      configKey="coinHints"
    />
  );
}
